import type { Market } from 'app/shared/types/Market';

export type TopMarkets = {
  topRentalMarkets: Array<Market>;
};

export function decorate(market: Market, queryString: string) {
  return { ...market, url: market.url + queryString };
}
